import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApiData } from "../../contexts/ApiData";
import { useTranslations } from "../../contexts/Translation";
import { useOrganizations } from "../../contexts/UserProvider";
import { useSurvey } from "../../contexts/Survey";
import { Group } from "../../types";
import styles from "./SidePanel.module.css";

const accessLabel = (accessibleBy: string) => `surveyForm.accessibleBy${accessibleBy.charAt(0).toUpperCase()}${accessibleBy.slice(1)}`;

const AccessCard = ({ onShare }: { onShare: () => void }) => {
  const t = useTranslations("surveys");
  const { get } = useApiData();
  const { currentOrganization } = useOrganizations();
  const { survey, isOwner } = useSurvey();
  const [groups, setGroups] = useState<Group[]>([]);
  const hasGroups = survey?.accessibleBy === "selectedGroups" && (survey.groupsWithAccess || []).length > 0;

  useEffect(() => {
    if (!hasGroups || !currentOrganization) {
      return;
    }
    const call = async () => {
      const result = await get(`/organization/${currentOrganization}/groups`);
      setGroups(result || []);
    };
    call();
  }, [get, hasGroups, currentOrganization]);

  if (!survey) {
    return null;
  }
  const groupNames = (survey.groupsWithAccess || []).map((id) => groups.find((g) => g.id === id)?.name).filter(Boolean);

  return (
    <section className={styles.card} aria-labelledby='access-heading'>
      <h2 id='access-heading' className={styles.heading}>
        {t("accessHeading")}
      </h2>
      <p className={styles.text}>
        <strong>{t(accessLabel(survey.accessibleBy || "me"))}</strong>
      </p>
      {hasGroups && groupNames.length > 0 && <p className={styles.text}>{t("sharedWithGroups", groupNames.join(", "))}</p>}
      <p className={styles.text}>{t("nothingPublished")}</p>
      <div className={styles.actions}>
        {isOwner && (
          <button type='button' className={styles.button} onClick={onShare}>
            {t("shareWithGroup")}
          </button>
        )}
        {survey.status === "finished" && (
          <Link className={styles.button} to='/card'>
            {t("eligibleForCard")}
          </Link>
        )}
      </div>
    </section>
  );
};

export default AccessCard;
